export const YesNo = [
    {
        name: "Yes",
        vals: "Yes",
    },
    {
        name: "No",
        vals: "No",
    },
];